import React, { Component } from "react";
import Select from "./common/select2";
import { AddCustomCut } from "./partial/addCustomCut";
import { SelectCustomerJob } from "./partial/selectCustomerJob";
import ServiceDiscountModal from "./partial/ServiceDiscountModal";
import ProductSelectionModal from "./partial/ProductSelectionModal";
import BootstrapTable from "react-bootstrap-table-next";

// UPDATED: Import the shared pricing module instead of old serviceUtils
import {
  SharedRequestPricing,
  SharedServicePricing
} from './views/services/sharedPricingCalculations';

import "react-bootstrap-table/css/react-bootstrap-table.css";
import { HTTPService } from "./../services/httpService";
import InventoryAPI from "./../services/inventoryService";
import _ from "lodash";

const API = new HTTPService();

// Helper to build V2 API URL for installer services (full catalog - for installers/specialists)
const buildInstallerServicesUrl = (installerId, params) => {
  const queryParams = new URLSearchParams({
    vehicleSize: params.vehicleSize,
    catalog: params.catalog,
    installerCategory: params.installerCategory,
    ...(params.trimId && { trimId: params.trimId })
  });
  return `/api/installer-services/installer/${installerId}?${queryParams}`;
};

// Helper to build V2 API URL for dealer template services (filtered by dealer's template)
const buildDealerTemplateUrl = (installerId, params) => {
  const queryParams = new URLSearchParams({
    vehicleSize: params.vehicleSize,
    catalog: params.catalog,
    installerCategory: params.installerCategory,
    dealerId: params.dealerId,
    ...(params.trimId && { trimId: params.trimId })
  });
  return `/api/installer-services/installer/${installerId}/template?${queryParams}`;
};

// Helper to map V2 response to maintain backward compatibility
const mapV2Services = (services) => {
  return services.map(service => ({
    ...service,
    // Map installer_service_id to service_id for downstream compatibility
    service_id: service.installer_service_id || service.service_id,
    // Keep original for reference if needed
    _original_installer_service_id: service.installer_service_id
  }));
};

export default class ServiceForm extends Component {
  state = {
    services: [],
    errors: {},
    selectedServices: [],
    categories: [],
    selectedService: {},
    selectedCategory: "",
    selectedDiscount: 0,
    displayServices: [],
    // UPDATED: These will be calculated using shared pricing module
    totalCost: parseFloat(this.props.total),
    totalDiscountAmount: 0,
    totalDiscounted: 0,
    totalDuration: 0,
    totalWholesale: 0,
    totalRetail: 0,
    totalMargin: 0,
    selectedServicePrice: "",
    message: "Requested Work",
    showCustom: false,
    showDisc: false,
    showServiceDiscount: false,
    serviceToDiscount: null,
    showProductSelection: false,
    serviceToSelectProduct: null,
    estimateDesc: "",
    estimateCost: 0,
    estimateDuration: 0,
    custJobs: [],
    showWholesalePricing: false,
    retailPriceOverrides: {},
    // Product selection: map of category name -> boolean (has products)
    categoryHasProducts: {},
  };

  // Enhanced componentDidUpdate with dual pricing support (unchanged)
  async componentDidUpdate(prevProps) {
    if (
      this.props.vehicle !== prevProps.vehicle ||
      this.props.customerType !== prevProps.customerType
    ) {
      let allServices = [];

      if (this.props.userType === "dealer") {
        // DEALER creating job: Use /template endpoint to filter by dealer's assigned template
        const specialistId = this.props.specialist || this.props.typeId;
        const dealerId = this.props.typeId;

        const baseParams = {
          vehicleSize: this.props.vehicle.size,
          catalog: 'WHOLE',
          installerCategory: this.props.category,
          dealerId: dealerId,
          trimId: this.props.vehicle.id_car_trim
        };

        try {
          const wholesaleUrl = buildDealerTemplateUrl(specialistId, baseParams);
          const retailUrl = buildDealerTemplateUrl(specialistId, { ...baseParams, catalog: 'RETAIL' });

          // V2 API: Handle wrapped response format
          const wholesaleResponse = await API.get(wholesaleUrl);
          const retailResponse = await API.get(retailUrl);

          // Extract data from wrapped response and map service IDs
          const wholesaleServices = mapV2Services(wholesaleResponse.data.data || wholesaleResponse.data);
          const retailServices = mapV2Services(retailResponse.data.data || retailResponse.data);

          allServices = this.mergeServicePricing(wholesaleServices, retailServices);
        } catch (error) {
          console.error("Error fetching dealer services:", error);
          const wholesaleUrl = buildDealerTemplateUrl(specialistId, baseParams);
          const wholesaleResponse = await API.get(wholesaleUrl);
          const wholesaleServices = mapV2Services(wholesaleResponse.data.data || wholesaleResponse.data);

          allServices = wholesaleServices.map(service => ({
            ...service,
            wholesale_price: service.service_cost,
            retail_price: service.service_cost
          }));
        }
      } else {
        // INSTALLER/SPECIALIST creating job: Use full catalog endpoint (no template filtering)
        // Catalog type depends on customer: RETAIL for retail customers, WHOLE for wholesale
        const serviceParams = {
          vehicleSize: this.props.vehicle.size,
          catalog: _.upperCase(this.props.customerType),
          installerCategory: this.props.category,
          trimId: this.props.vehicle.id_car_trim
        };
        const servicesUrl = buildInstallerServicesUrl(this.props.typeId, serviceParams);

        // V2 API: Handle wrapped response format and map service IDs
        const response = await API.get(servicesUrl);
        allServices = mapV2Services(response.data.data || response.data);
      }

      // DEBUG: Log full services data structure from database
      console.log("=== SERVICES DATA FROM DATABASE ===");
      console.log("Full services array:", JSON.parse(JSON.stringify(allServices)));
      console.log("Number of services:", allServices.length);
      if (allServices.length > 0) {
        console.log("Sample service structure:", allServices[0]);
        console.log("All service keys:", Object.keys(allServices[0]));
      }
      console.log("===================================");

      let categories = [...new Set(allServices.map((x) => x.service_category))];
      let services = [...new Set(allServices)];

      if (this.props.userType === "dealer") {
        services = services.filter(
          (service) => service.description !== "Custom"
        );
      }
        this.setState({ services, categories, selectedService: "" }, () => {
            this.handleServiceHintPreselection();
            // Load products to check which categories have products (installer only)
            if (this.props.userType === "installer") {
              this.loadCategoryProducts();
            }
        });

      if (this.props.currentStep === 99 && this.props.notes && this.props.notes.Request_id) {
        const jobsQuery = "/requestimates/requestbyID/?Id=" + this.props.notes.Request_id;
        const { data: jobs } = await API.get(jobsQuery);

        // Show job list modal - this is the workaround to populate services
        // Protection fields will be preserved via getProtectionFieldsFromProps() in addService()
        this.setState({
          custJobs: jobs,
          selectedJob: "",
          showJobList: jobs.length > 0
        });
      }
    }

    if (this.props.serviceHint !== prevProps.serviceHint && this.state.categories.length > 0) {
        this.handleServiceHintPreselection();
    }
  }

  // Load products and build map of which categories have products
  loadCategoryProducts = async () => {
    try {
      // Get all products for this installer
      const products = await InventoryAPI.getProducts(this.props.typeId);

      // Build map of category_name -> true for categories that have products
      const categoryHasProducts = {};
      (products || []).forEach(product => {
        if (product.category_name) {
          categoryHasProducts[product.category_name] = true;
        }
      });

      this.setState({ categoryHasProducts });
    } catch (error) {
      console.error('Error loading products for categories:', error);
    }
  };

  // Service hint preselection (unchanged)
  handleServiceHintPreselection = () => {
    console.log("handleServiceHintPreselection called");
    
    if (this.props.serviceHint && 
        !this.state.selectedCategory && 
        this.state.categories.length > 0) {
        
        const serviceHintMap = {
            'PPF': 'PPF',
            'TINT': 'Glass/Tint',
            'PAINT': 'Other Services',
            'DETAIL': 'Other Services'
        };

        const suggestedCategory = serviceHintMap[this.props.serviceHint];
        
        if (suggestedCategory && this.state.categories.includes(suggestedCategory)) {
            const dispServices = this.state.services.filter(
                (service) => service.service_category === suggestedCategory
            );
            const displayServices = dispServices.map((item) => {
              if (this.props.userType === "dealer") {
                return item.description;
              }
              return {
                value: item.description,
                label: `${item.description} - $${(item.service_cost || 0).toFixed(2)}`
              };
            });
            
            this.setState({
                displayServices,
                selectedCategory: suggestedCategory,
                selectedService: { description: "" },
                estimateCost: 0,
                estimateDuration: 0,
                estimateDesc: "",
            });
        }
    }
  };

  // Helper method to merge wholesale and retail pricing (unchanged)
  mergeServicePricing = (wholesaleServices, retailServices) => {
    return wholesaleServices.map(wholesaleService => {
      const retailService = retailServices.find(retail => 
        retail.master_service_id === wholesaleService.master_service_id ||
        retail.service_id === wholesaleService.service_id
      );
      
      return {
        ...wholesaleService,
        wholesale_price: wholesaleService.service_cost,
        retail_price: retailService ? retailService.service_cost : wholesaleService.service_cost
      };
    });
  };

  // Toggle pricing view for dealers (unchanged)
  togglePricingView = () => {
    this.setState(prevState => ({
      showWholesalePricing: !prevState.showWholesalePricing
    }));
  };

  // Handle retail price changes for dealers (unchanged)
  handleRetailPriceChange = (serviceId, newPrice) => {
    this.setState(prevState => {
      const updatedOverrides = {
        ...prevState.retailPriceOverrides,
        [serviceId]: newPrice
      };
      
      const updatedServices = prevState.selectedServices.map(service => {
        if (service.service_id === serviceId) {
          return {
            ...service,
            retail_price: newPrice
          };
        }
        return service;
      });
      
      return {
        retailPriceOverrides: updatedOverrides,
        selectedServices: updatedServices
      };
    }, this.calculateTotals);
  };

  // UPDATED: Use shared pricing module for all calculations
  calculateTotals = () => {
    console.log("calculateTotals called with services:", this.state.selectedServices);
    
    // Update selectedServices with current retail price overrides
    let updatedServices = this.state.selectedServices.map(service => ({
      ...service,
      retail_price: this.state.retailPriceOverrides[service.service_id] !== undefined
        ? this.state.retailPriceOverrides[service.service_id]
        : (service.retail_price || service.service_cost)
    }));
    
    if (updatedServices.length === 0) {
      this.setState({
        selectedServices: [],
        totalCost: 0,
        totalDiscountAmount: 0,
        totalDiscounted: 0,
        totalDuration: 0,
        totalWholesale: 0,
        totalRetail: 0,
        totalMargin: 0,
        hasDiscounts: false
      });
      
      this.props.handleServices([], 0, 0);
      return;
    }

    // UPDATED: Use shared pricing module for calculations
    const originalTotal = SharedRequestPricing.calculateRequestTotal(updatedServices);
    const totalDiscount = SharedRequestPricing.calculateRequestDiscount(updatedServices);
    const finalAmount = SharedRequestPricing.calculateRequestFinalAmount(updatedServices);
    const totalDuration = SharedRequestPricing.calculateTotalDuration(updatedServices);
    
    // Check if any service has a discount
    const hasDiscounts = updatedServices.some(
      service => (service.service_discount || 0) > 0
    );
    
    // Calculate dealer-specific totals if applicable
    let totalWholesale = 0;
    let totalRetail = 0;
    let totalMargin = 0;
    
    if (this.props.userType === "dealer") {
      totalWholesale = finalAmount; // What dealer pays (post-discount)
      totalRetail = updatedServices.reduce((sum, service) => {
        return sum + (service.retail_price || service.service_cost);
      }, 0);
      totalMargin = totalRetail - totalWholesale;
    }
    
    // Update state with calculated values
    this.setState({
      selectedServices: updatedServices,
      totalCost: originalTotal,
      totalDiscountAmount: totalDiscount,
      totalDiscounted: finalAmount,
      totalDuration,
      totalWholesale,
      totalRetail,
      totalMargin,
      hasDiscounts,
      estimateCost: 0,
      estimateDuration: 0,
    });
    
    // UPDATED: Pass calculated values to parent using shared module results
    console.log("Passing to parent:", {
      services: updatedServices,
      total: originalTotal,
      discount: totalDiscount
    });
    
    this.props.handleServices(
      updatedServices,
      originalTotal,    // Use shared module calculation
      totalDiscount     // Use shared module calculation
    );
  };

  // Helper to get protection fields from props for a service
  // Cache for original services from props (used for protection field lookup)
  _originalServicesCache = null;

  getProtectionFieldsFromProps = (serviceId) => {
    if (this.props.currentStep !== 99) {
      return {};
    }

    // Use cached services if available, otherwise use current props
    // This prevents issues when props.services changes during the add loop
    const servicesToSearch = this._originalServicesCache || this.props.services;

    if (!servicesToSearch || servicesToSearch.length === 0) {
      return {};
    }

    // Find matching service by service_id
    const propsService = servicesToSearch.find(s => s.service_id === serviceId);

    if (!propsService) {
      return {};
    }
    // Return protection-related fields
    return {
      service_state: propsService.service_state,
      started_at: propsService.started_at,
      started_by: propsService.started_by,
      finished_at: propsService.finished_at,
      finished_by: propsService.finished_by,
      materials: propsService.materials,
      materials_data: propsService.materials_data,
      material_brand: propsService.material_brand,
      material_product: propsService.material_product,
      material_roll_number: propsService.material_roll_number,
      // Product recommendation fields
      recommended_product_id: propsService.recommended_product_id,
      recommended_product_name: propsService.recommended_product_name,
      recommended_product_brand: propsService.recommended_product_brand,
    };
  };

  // UPDATED: Simplify addService to use shared calculations
  addService = () => {
    let selectedServices = Array.from(this.state.selectedServices);

    this.setState({
      message: "NOTE : Price may vary based on selected model",
      showCustom: false,
    });

    let goodToGo = 0;

    // Handle existing job services (editJob case)
    if (this.state.selectedService.request_id) {
      // Get protection fields from props if available
      const protectionFields = this.getProtectionFieldsFromProps(this.state.selectedService.service_id);

      let serviceSelected = {
        description: this.state.selectedService.custom_description,
        service_category: this.state.selectedService.service_category,
        service_cost: this.state.selectedService.service_cost,
        service_discount: this.state.selectedService.service_discount || 0,
        service_amount: this.state.selectedService.service_amount,
        service_id: this.state.selectedService.service_id,
        data_collect: this.state.selectedService.data_collect,
        duration_days: this.state.selectedService.duration_days,
        installer_category: this.state.selectedService.installer_category,
        installer_id: this.state.selectedService.installer_id,
        market_size: this.state.selectedService.market_size,
        overrides: this.state.selectedService.overrides,
        vehicle_size: this.state.selectedService.vehicle_size,
        wholesale_price: this.state.selectedService.wholesale_price || this.state.selectedService.service_cost,
        retail_price: this.state.selectedService.retail_price || this.state.selectedService.service_cost,
        // Product recommendation fields (from existing service or null)
        recommended_product_id: this.state.selectedService.recommended_product_id || null,
        recommended_product_name: this.state.selectedService.recommended_product_name || null,
        recommended_product_brand: this.state.selectedService.recommended_product_brand || null,
        // Merge protection fields from props (for edit mode lock icon)
        ...protectionFields,
      };

      selectedServices.push(serviceSelected);
      this.setState({ selectedServices }, this.calculateTotals);
    } else {
      // Handle new service selection
      if (!selectedServices.find(
          (svc) => svc.service_id === this.state.selectedService.service_id
        )
      ) {
        // Handle service overrides
        if (this.state.selectedService.overrides != null) {
          const parentServices = this.state.selectedService.overrides.split(",");
          
          for (let x = 0; x < parentServices.length; x++) {
            let selectedServicesIDs = this.state.selectedServices.map(
              (id) => id.service_id
            );
            let foundIndex = selectedServicesIDs.indexOf(
              parseInt(parentServices[x], 10)
            );
            
            if (foundIndex > -1) {
              selectedServices.splice(foundIndex, 1);
            }
            
            this.setState({
              message: "NOTE : Price may vary based on selected model",
            });
          }
        } else {
          // Check for conflicts
          for (let x = 0; x < selectedServices.length; x++) {
            if (selectedServices[x].overrides != null) {
              const childServices = selectedServices[x].overrides.split(",");
              let found = childServices.indexOf(
                this.state.selectedService.service_id.toString()
              );
              
              if (found > -1) {
                goodToGo = 1;
                this.setState({
                  message: "Already included in a selected service",
                });
              }
            }
          }
        }
        
        if (goodToGo === 0) {
          // DEBUG: Log the service being added with its service_id
          console.log("=== ADDING SERVICE TO REQUEST ===");
          console.log("Selected service from state:", this.state.selectedService);
          console.log("Service ID being added:", this.state.selectedService.service_id);
          console.log("Service description:", this.state.selectedService.description);
          console.log("=================================");

          let serviceSelected = {
            description: this.state.selectedService.description,
            service_category: this.state.selectedService.service_category,
            service_cost: this.state.selectedService.service_cost,
            service_discount: 0,
            service_discount_percent: 0,
            service_amount: this.state.selectedService.service_cost,
            service_id: this.state.selectedService.service_id,
            data_collect: this.state.selectedService.data_collect,
            duration_days: this.state.selectedService.duration_days,
            installer_category: this.state.selectedService.installer_category,
            installer_id: this.state.selectedService.installer_id,
            market_size: this.state.selectedService.market_size,
            overrides: this.state.selectedService.overrides,
            vehicle_size: this.state.selectedService.vehicle_size,
            wholesale_price: this.state.selectedService.wholesale_price || this.state.selectedService.service_cost,
            retail_price: this.state.retailPriceOverrides[this.state.selectedService.service_id] !== undefined
              ? this.state.retailPriceOverrides[this.state.selectedService.service_id]
              : (this.state.selectedService.retail_price || this.state.selectedService.service_cost),
            // Product recommendation fields
            recommended_product_id: null,
            recommended_product_name: null,
            recommended_product_brand: null,
          };
          
          selectedServices.push(serviceSelected);
          
          // UPDATED: Use calculateTotals for consistent calculations
          this.setState({ selectedServices }, this.calculateTotals);
          
          if (serviceSelected.service_cost === 0) {
            this.setState({ showCustom: true });
          }
        }
      }
    }
  };

  // Check if a service is protected from deletion (has been worked on or has materials)
  isServiceProtected = (service) => {
    // Check if service has been started or finished
    const hasWorkStarted = service.service_state === 'started' || service.service_state === 'finished';

    // Check if service has materials collected
    const hasMaterials = (service.materials && service.materials.length > 0) ||
                         (service.material_brand && service.material_product) ||
                         (service.materials_data && (typeof service.materials_data === 'string'
                           ? service.materials_data.length > 2
                           : Object.keys(service.materials_data).length > 0));

    return hasWorkStarted || hasMaterials;
  };

  // Get protection reason for tooltip
  getProtectionReason = (service) => {
    const reasons = [];
    if (service.service_state === 'started') reasons.push('work in progress');
    if (service.service_state === 'finished') reasons.push('work completed');

    const hasMaterials = (service.materials && service.materials.length > 0) ||
                         (service.material_brand && service.material_product) ||
                         (service.materials_data && (typeof service.materials_data === 'string'
                           ? service.materials_data.length > 2
                           : Object.keys(service.materials_data).length > 0));
    if (hasMaterials) reasons.push('materials collected');

    return reasons.length > 0 ? `Cannot remove: ${reasons.join(', ')}` : '';
  };

  // Service removal (updated to use calculateTotals)
  removeService = (row) => {
    // Check if service is protected
    if (this.isServiceProtected(row)) {
      alert(`This service cannot be removed because it has ${this.getProtectionReason(row).replace('Cannot remove: ', '')}.`);
      return;
    }

    let selectedServices = Array.from(this.state.selectedServices).filter(
      (service) => service.service_id !== row.service_id
    );

    const retailPriceOverrides = { ...this.state.retailPriceOverrides };
    delete retailPriceOverrides[row.service_id];

    this.setState({
      selectedServices,
      retailPriceOverrides
    }, this.calculateTotals);
  };

  // Service discount handling (updated)
  openServiceDiscountModal = (serviceId) => {
    const serviceToDiscount = this.state.selectedServices.find(
      service => service.service_id === serviceId
    );

    if (serviceToDiscount) {
      this.setState({
        showServiceDiscount: true,
        serviceToDiscount
      });
    }
  };

  // Product selection modal handlers
  openProductSelectionModal = (serviceId) => {
    const serviceToSelectProduct = this.state.selectedServices.find(
      service => service.service_id === serviceId
    );

    if (serviceToSelectProduct) {
      this.setState({
        showProductSelection: true,
        serviceToSelectProduct
      });
    }
  };

  handleProductSelection = (serviceId, productId, productName, productBrand) => {
    // Create new array with new object for updated service (proper immutable update)
    const selectedServices = this.state.selectedServices.map(s => {
      if (s.service_id === serviceId) {
        return {
          ...s,
          recommended_product_id: productId,
          recommended_product_name: productName,
          recommended_product_brand: productBrand
        };
      }
      return s;
    });

    this.setState({
      selectedServices,
      showProductSelection: false,
      serviceToSelectProduct: null
    }, () => {
      // Notify parent of updated services
      this.props.handleServices(
        selectedServices,
        this.state.totalCost,
        this.state.totalDiscountAmount
      );
    });
  };

  // UPDATED: Use shared pricing validation for discounts
  handleServiceDiscount = (serviceId, discountAmount, discountPercent) => {
    const selectedServices = [...this.state.selectedServices];
    const index = selectedServices.findIndex(s => s.service_id === serviceId);
    
    if (index > -1) {
      // UPDATED: Use shared pricing validation
      const validationResult = SharedServicePricing.validateServiceDiscount(
        selectedServices[index], 
        discountAmount
      );
      
      if (!validationResult.isValid) {
        console.warn("Invalid discount amount:", discountAmount, "Max:", validationResult.maxDiscount);
      }
      
      selectedServices[index].service_discount = validationResult.validatedDiscount;
      selectedServices[index].service_discount_percent = discountPercent;
      selectedServices[index].service_amount = 
        selectedServices[index].service_cost - validationResult.validatedDiscount;
      
      this.setState({ 
        selectedServices,
        showServiceDiscount: false,
        serviceToDiscount: null
      }, this.calculateTotals);
    }
  };

  // Custom estimate handling (updated)
  handleCustomEstimate = (desc, cost, duration) => {
    let selectedServices = [...this.state.selectedServices];
    let index = selectedServices.findIndex((item) => item.service_cost === 0);
    
    if (index > -1) {
      selectedServices[index].description = desc;
      selectedServices[index].service_cost = parseFloat(cost);
      selectedServices[index].duration_days = parseFloat(duration);
      selectedServices[index].service_amount = parseFloat(cost);
    }
    
    this.setState({
      selectedServices,
      estimateDesc: desc,
      estimateCost: parseFloat(cost),
      estimateDuration: parseFloat(duration),
      showCustom: false,
    }, this.calculateTotals);
  };

  // Category and service selection (unchanged)
  handleCategoryChange = (event) => {
    this.setState({
      selectedService: { description: "" },
      displayServices: [],
    });

    const { value } = event.target;

    const dispServices = this.state.services.filter(
      (service) => service.service_category === value
    );
    const displayServices = dispServices.map((item) => {
      if (this.props.userType === "dealer") {
        return item.description;
      }
      return {
        value: item.description,
        label: `${item.description} - $${(item.service_cost || 0).toFixed(2)}`
      };
    });

    this.setState({
      displayServices,
      selectedCategory: value,
      estimateCost: 0,
      estimateDuration: 0,
      estimateDesc: "",
    });
  };

  handleServiceChange = (event) => {
    const { value } = event.target;
    const service = this.state.services.find(
      (service) =>
        service.description === value &&
        service.service_category === this.state.selectedCategory
    );
    this.setState({ selectedService: service });
  };

  // Remove all discounts (updated)
  removeAllDiscounts = () => {
    let selectedServices = Array.from(this.state.selectedServices);
    
    for (let i = 0; i < selectedServices.length; i++) {
      selectedServices[i].service_discount = 0;
      selectedServices[i].service_discount_percent = 0;
      selectedServices[i].service_amount = selectedServices[i].service_cost;
    }

    this.setState({ selectedServices }, this.calculateTotals);
  };

  // Close handlers (unchanged)
  addCustomClose = () => {
    let selectedServices = [...this.state.selectedServices];
    let index = selectedServices.findIndex((item) => item.service_cost === 0);
    
    if (index > -1) {
      selectedServices.splice(index, 1);
    }
    
    this.setState({ 
      showCustom: false,
      showServiceDiscount: false,
      selectedServices 
    }, this.calculateTotals);
  };

  handleJobSelect = async (selectRequest) => {
    // Cache original services from props BEFORE the add loop
    // This is needed because props.services changes as services are added
    if (this.props.currentStep === 99 && this.props.services) {
      this._originalServicesCache = [...this.props.services];
    }

    // Load services from the selected job
    // Protection fields will be preserved via getProtectionFieldsFromProps() in addService()
    const { data: services } = await API.get(
      `/requestServices/${selectRequest.Request_id}`
    );

    this.setState({
      selectedServices: [],
      totalCost: 0,
      totalDiscountAmount: 0,
      totalDiscounted: 0,
      totalDuration: 0,
      totalWholesale: 0,
      totalRetail: 0,
      totalMargin: 0
    });

    for (let i = 0; i < services.length; i++) {
      this.setState({ selectedService: services[i] }, () => {
        this.addService();
      });
    }

    this.setState({ showJobList: false });
  };

  handleClose = () => {
    this.setState({ 
      showJobList: false,
      showServiceDiscount: false,
      serviceToDiscount: null 
    });
  };

  render() {
    const { showWholesalePricing } = this.state;
    
    // Table columns (unchanged - keeping existing UI)
    const columns = [
      {
        dataField: "delete",
        text: "Action",
        formatter: (_, row) => {
          const isProtected = this.isServiceProtected(row);
          const protectionReason = isProtected ? this.getProtectionReason(row) : '';

          if (isProtected) {
            return (
              <i
                className="fa fa-lock text-muted"
                style={{ cursor: "not-allowed" }}
                title={protectionReason}
              ></i>
            );
          }

          return (
            <i
              className="fa fa-trash text-danger"
              style={{ cursor: "pointer" }}
              onClick={() => this.removeService(row)}
              title="Remove service"
            ></i>
          );
        },
        headerStyle: { width: "80px", textAlign: "center" },
        align: "center",
      },
      {
        dataField: "service_category",
        text: "Category",
      },
      {
        dataField: "description",
        text: "Service",
        formatter: (cell, row) => {
          const hasProduct = row.recommended_product_id != null;
          const productDisplay = hasProduct
            ? (row.recommended_product_brand
                ? `${row.recommended_product_brand} - ${row.recommended_product_name}`
                : row.recommended_product_name)
            : null;

          // Only show product button if category has products defined
          const categoryHasProducts = this.state.categoryHasProducts[row.service_category] || false;
          const showProductButton = this.props.userType === "installer" && categoryHasProducts;

          return (
            <div className="d-flex align-items-start justify-content-between">
              <div className="flex-grow-1">
                <span>{cell}</span>
                {hasProduct && (
                  <div className="small text-success">
                    <i className="fa fa-check mr-1"></i>
                    {productDisplay}
                  </div>
                )}
              </div>
              {showProductButton && (
                <button
                  className={`btn btn-sm ml-2 ${hasProduct ? 'btn-outline-success' : 'btn-outline-secondary'}`}
                  onClick={() => this.openProductSelectionModal(row.service_id)}
                  title={hasProduct ? `Change product: ${productDisplay}` : 'Select product'}
                  style={{ minWidth: '32px', flexShrink: 0 }}
                >
                  <i className={`fa ${hasProduct ? 'fa-check' : 'fa-cube'}`}></i>
                </button>
              )}
            </div>
          );
        }
      },
      // Pricing columns for dealers
      ...(this.props.userType === "dealer" ? [
        {
          dataField: "pricing",
          text: showWholesalePricing ? "Wholesale Pricing" : "Retail Price",
          formatter: (_, row) => {
            if (showWholesalePricing) {
              const price = row.wholesale_price || row.service_cost;
              return <span>${price.toFixed(2)}</span>;
            } else {
              const currentRetailPrice = this.state.retailPriceOverrides[row.service_id] !== undefined 
                ? this.state.retailPriceOverrides[row.service_id]
                : (row.retail_price || row.service_cost);
              
              return (
                <div className="d-flex align-items-center">
                  <span className="mr-1">$</span>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    value={currentRetailPrice || ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      const numericValue = value === '' ? 0 : parseFloat(value);
                      this.handleRetailPriceChange(row.service_id, numericValue);
                    }}
                    onFocus={(e) => e.target.select()}
                    className="form-control form-control-sm"
                    style={{ width: '90px' }}
                    placeholder="0.00"
                  />
                </div>
              );
            }
          }
        },
        ...(showWholesalePricing ? [{
          dataField: "margin",
          text: "Margin",
          formatter: (_, row) => {
            const wholesale = row.wholesale_price || row.service_cost;
            const retail = this.state.retailPriceOverrides[row.service_id] !== undefined
              ? this.state.retailPriceOverrides[row.service_id]
              : (row.retail_price || row.service_cost);
            const margin = retail - wholesale;
            return <span className="text-success">${margin.toFixed(2)}</span>;
          }
        }] : [])
      ] : [
        // Original columns for non-dealers
        {
          dataField: "service_cost",
          text: "Cost",
          formatter: (cell) => (
            <span>${cell.toFixed(2)}</span>
          )
        },
        {
          dataField: "service_discount",
          text: "Discount",
          formatter: (cell, row) => (
            <div>
              {cell > 0 ? (
                <>
                  <span className="text-success font-weight-bold">
                    ${(cell || 0).toFixed(2)}
                  </span>
                  {row.service_discount_percent > 0 && (
                    <span className="ml-1 text-muted">
                      ({row.service_discount_percent}%)
                    </span>
                  )}
                </>
              ) : (
                <span>$0.00</span>
              )}
              <button 
                className="btn btn-sm btn-outline-primary ml-2"
                onClick={() => this.openServiceDiscountModal(row.service_id)}
              >
                <i className="fa fa-percent"></i>
              </button>
            </div>
          )
        }
      ]),
      ...(this.props.userType !== "dealer" ? [{
        dataField: "service_amount",
        text: "Final Price",
        formatter: (_, row) => (
          <span>
            ${(row.service_amount || row.service_cost - (row.service_discount || 0)).toFixed(2)}
          </span>
        )
      }] : []),
      {
        dataField: "duration_days",
        text: "Duration",
      },
    ];

    if (this.props.currentStep !== 3 && this.props.currentStep !== 99) {
      return null;
    }

    let selectedServices = [...this.state.selectedServices];
    console.log("Available Services", selectedServices);

    return (
      <React.Fragment>
        {/* Service selection form (unchanged) */}
        <form className="form-container p-5">
          <div className="form-row justify-content-md-center">
            <div className="form-group col-md-2 text-center">
              <label htmlFor="vin" className="bold">
                Pick Service(s)
              </label>
            </div>
            <div className="form-group col-md-3">
              <Select
                name="category"
                label=" "
                options={this.state.categories}
                value={this.state.selectedCategory}
                onChange={this.handleCategoryChange}
              />
            </div>
            <div className="form-group col-md-4">
              <Select
                name="service"
                label=" "
                options={this.state.displayServices}
                value={this.state.selectedService.description}
                onChange={this.handleServiceChange}
              />
            </div>
            <div className="form-group col-md-3">
              <button
                className="btn btn-block btn-success"
                type="button"
                disabled={!this.state.selectedService.description}
                onClick={this.addService}
              >
                Add Service
              </button>
            </div>
            
            {/* Modals (unchanged) */}
            <AddCustomCut
              show={this.state.showCustom}
              onHide={this.addCustomClose}
              estimateDesc={this.state.estimateDesc}
              estimateCost={this.state.estimateCost}
              estimateDuration={this.state.estimateDuration}
              handleCustomEstimate={this.handleCustomEstimate}
              addService={this.addService}
            />
            {this.props.userType !== "dealer" &&
              this.state.showServiceDiscount &&
              this.state.serviceToDiscount && (
                <ServiceDiscountModal
                  show={this.state.showServiceDiscount}
                  onHide={this.handleClose}
                  service={this.state.serviceToDiscount}
                  onApplyDiscount={this.handleServiceDiscount}
                />
              )}
            {this.props.userType === "installer" &&
              this.state.showProductSelection &&
              this.state.serviceToSelectProduct && (
                <ProductSelectionModal
                  show={this.state.showProductSelection}
                  onHide={() => this.setState({ showProductSelection: false, serviceToSelectProduct: null })}
                  service={this.state.serviceToSelectProduct}
                  installerId={this.props.typeId}
                  onSelectProduct={this.handleProductSelection}
                />
              )}
          </div>
          {this.props.userType !== "dealer" &&
            this.state.selectedServices.length > 0 &&
            this.state.hasDiscounts && (
              <div className="form-row justify-content-md-center mt-3">
                <div className="form-group col-md-4">
                  <button
                    className="btn shadow btn-warning"
                    type="button"
                    onClick={this.removeAllDiscounts}
                  >
                    Remove All Discounts
                  </button>
                </div>
              </div>
            )}
        </form>

        {/* Services table and totals display (unchanged UI, updated calculations) */}
        {this.state.selectedServices.length > 0 && (
          <div>
            <div className="text-center p-5">
              <div className="d-flex align-items-center justify-content-center">
                {this.props.userType === "dealer" && (
                  <button
                    className="btn btn-sm btn-link text-muted p-1 mr-2"
                    type="button"
                    onClick={this.togglePricingView}
                    title={showWholesalePricing ? 'Switch to Retail Pricing' : 'Switch to Wholesale Pricing'}
                    style={{ fontSize: '0.9rem' }}
                  >
                    <i className={`fa ${showWholesalePricing ? 'fa-eye' : 'fa-user'}`}></i>
                  </button>
                )}
                <h5 className="bold mb-0">{this.state.message}</h5>
              </div>
            </div>
            <div className="text-center table-responsive">
              <BootstrapTable
                key={this.props.userType === "dealer" ? `dealer-${showWholesalePricing}` : "installer"}
                keyField="service_id"
                data={selectedServices}
                columns={columns}
              />
            </div>
            <div className="row">
              <div className="col text-right">
                {this.state.selectedServices && (
                  <div>
                    {this.props.userType === "dealer" ? (
                      <div>
                        <div>
                          <strong>Total:</strong> ${showWholesalePricing 
                            ? this.state.totalWholesale.toFixed(2) 
                            : this.state.totalRetail.toFixed(2)}
                        </div>
                        {showWholesalePricing && (
                          <div>
                            <strong>Total Margin:</strong> <span className="text-success">${this.state.totalMargin.toFixed(2)}</span>
                          </div>
                        )}
                      </div>
                    ) : (
                      <>
                        <div><strong>Total Cost:</strong> ${this.state.totalCost.toFixed(2)}</div>
                        <div><strong>Final Price:</strong> ${this.state.totalDiscounted.toFixed(2)}</div>
                      </>
                    )}
                  </div>
                )}
              </div>
              {this.props.userType !== "dealer" && this.state.totalDiscountAmount > 0 && (
                <div className="col text-center">
                  <strong>Total Discount:</strong> ${this.state.totalDiscountAmount.toFixed(2)}
                </div>
              )}
              <div className="col text-left">
                {this.state.selectedServices && (
                  <div><strong>Total Duration:</strong> {this.state.totalDuration} days</div>
                )}
              </div>
            </div>
          </div>
        )}
        <SelectCustomerJob
          showJobList={this.state.showJobList}
          onHide={this.handleClose}
          jobs={this.state.custJobs}
          onSelect={this.handleJobSelect}
          mode="select"
          step={this.props.currentStep}
        />
      </React.Fragment>
    );
  }
}